<template lang="pug">
  .b-user-tile
    ._tile
      UserAvatar(:user="user" :size="size")._image
      ._body.body(v-if="!short" :style="{ maxWidth: `calc(100% - ${12 + (size || 32)}px)` }")
        span._name.name(v-if="userTitle && !isLink" @click="$emit('nameClick')") {{ userTitle }}
        router-link._name.name(v-if="userTitle && isLink" :to="{ name: 'admin-user-detail', params: { userId: this.user.id, tab: 'common' } }") {{ userTitle }}
        span._slot(v-if="$slots.default") {{ label2 }}
          slot
        span._slot(v-if="label3") {{ label3 }}
    span._desc(v-if="label && !short") {{ label }}
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue';

export default {
  name: 'UserTile',
  components: { UserAvatar },
  inject: {
    positions: { default: null },
  },
  props: {
    route: String,
    label: String,
    label2: String,
    user: Object,
    short: Boolean,
    size: Number,
    fz: Number,
    isLink: Boolean,
  },
  computed: {
    userTitle() {
      if (!this.user) {
        return '';
      }

      return this.user.name ? `${this.user.name} ${this.user.surname}` : this.user.email;
    },
    label3() {
      return (this.positions?.() ?? {})[this.user.id];
    },
  },
};
</script>

<style scoped lang="scss">
.user-tile {
  display: flex;
  align-items: center;
  color: var(--color-dark-gray);
  justify-content: space-between;
  cursor: pointer;

  &__tile {
    display: flex;
    gap: 12px;
    align-items: center;
    &:hover {
      .author__name {
        color: var(--color-hover);
      }
    }
  }
  &__image {
    flex-shrink: 0;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.16));
  }

  &__body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2px;
  }

  &__slot {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    display: flex;
    align-items: center;
    letter-spacing: 0.01em;

    color: #788CA1;
  }

  &__name {
    display: block;
    color: var(--color-drak-gray);
    font-size: 14px;
    line-height: 17px;
    transition: color 0.3s;
    overflow-wrap: break-word;
  }
  &:hover &__name {
    color: var(--color-hover);
  }
  &__desc {
    font-weight: 500;
    font-size: 14px;
    margin-left: 20px;
    color: var(--color-middle-gray);
  }
}
</style>
